
import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {getBizList,getCmsList,getCourseList,getOfflineCourseList} from "../../api/service.js"
import $ from 'jquery'
export default{
    components:{
        myHeader,
        myFooter
    },

    data(){
        return {
          form:{},
          rules: {
            name: [
              { required: true, message: '请输入活动名称', trigger: 'blur' },
              { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            phone: [
              { required: true, message: '请选择活动区域', trigger: 'change' }
            ],
            email: [
              { required: true, message: '请选择活动区域', trigger: 'change' }
            ],
          }
        }
    },
    created(){

    },

    methods:{
      onSubmit(){

      }
    }
}



// WEBPACK FOOTER //
// ./src/pages/enterpriseEdition/agencies.js